import React from "react";
import { ShieldOff, FrameIcon, Wrench, Truck } from "lucide-react";

const ITEMS = [
  {
    icon: ShieldOff,
    title: "Print posters that get damaged quickly",
    body: "Without lamination, posters tear, fade, and curl long before the school year ends.",
  },
  {
    icon: FrameIcon,
    title: "Struggle to hang or display banners properly",
    body: "Untrimmed edges, missing grommets, no hardware—great print, awkward presentation.",
  },
  {
    icon: Wrench,
    title: "No tools to finish projects cleanly",
    body: "No vinyl cutter for decals, no laminator for protection, no banner kit for hanging.",
  },
  {
    icon: Truck,
    title: "Rely on outside vendors for final production",
    body: "Even when print is in-house, finishing keeps you waiting on someone else.",
  },
];

export default function FinishingMirror() {
  return (
    <section
      data-testid="finishing-mirror-section"
      className="relative bg-[#F4F6F4] py-24 md:py-32 border-b border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="max-w-3xl mb-14">
          <div className="text-xs uppercase tracking-[0.2em] font-bold text-teal mb-4">
            What Most Schools Are Dealing With
          </div>
          <h2
            data-testid="finishing-mirror-headline"
            className="font-serif text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-navy leading-tight"
          >
            Printing Is Only Half the Job
          </h2>
          <p className="mt-6 text-lg text-slate-600 leading-relaxed">
            Most schools:
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <div
                key={it.title}
                data-testid={`finishing-mirror-item-${i}`}
                className="bg-white border border-slate-200 rounded-2xl p-7 hover:border-teal/40 hover:shadow-md transition-all flex items-start gap-5"
              >
                <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-teal/10 text-teal flex items-center justify-center">
                  <Icon className="w-6 h-6" strokeWidth={2} />
                </div>
                <div>
                  <h3 className="font-serif text-lg md:text-xl font-bold text-navy mb-1.5 leading-snug">
                    {it.title}
                  </h3>
                  <p className="text-sm text-slate-600 leading-relaxed">{it.body}</p>
                </div>
              </div>
            );
          })}
        </div>

        <p
          data-testid="finishing-mirror-close"
          className="mt-14 max-w-3xl font-serif text-2xl sm:text-3xl font-bold text-navy italic"
        >
          That's why even great prints don't always look professional.
        </p>
      </div>
    </section>
  );
}
